var Toaster = /** @class */ (function () {
    function Toaster() {
    }
    return Toaster;
}());
export { Toaster };
